// Grey Palette
export const grey = {
  50: "#fafafa",
  100: "#f4f4f5",
  200: "#e4e4e7",
  300: "#d4d4d8",
  400: "#a1a1aa",
  450: "#909099",
  500: "#4f5352",
  600: "#363a39",
  700: "#272b2a",
  800: "#1b1f1e",
  900: "#121615",
};

// Primary Palette
export const primary = {
  50: "#edfffe",
  100: "#c2ffff",
  200: "#84feff",
  300: "#3ffdff",
  400: "#06f7f7",
  500: "#00dadc",
  600: "#00adb2",
  700: "#00878d",
  800: "#00686f",
  900: "#06565b",
};

export const aptosColor = primary[600];
export const negativeColor: string = "#F97373";
export const warningColor: string = "#f1c232";

// code block colors
export const codeBlockColor: string = "rgba(14,165,233,0.1)";
export const codeBlockColorClickableOnHover: string = "rgba(14,165,233,0.2)";
// use rgb for codeblock in modal otherwise it will be transparent and not very visible
export const codeBlockColorRgbLight: string = "#E3ECF3";
export const codeBlockColorRgbDark: string = "#212D32";
